import { render, staticRenderFns } from "./UploaderFile.vue?vue&type=template&id=059b0882&scoped=true&lang=pug&"
import script from "./UploaderFile.vue?vue&type=script&lang=js&"
export * from "./UploaderFile.vue?vue&type=script&lang=js&"
import style0 from "./UploaderFile.vue?vue&type=style&index=0&id=059b0882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059b0882",
  null
  
)

export default component.exports